module.exports = __webpack_public_path__ + "img/facebook.cacc948c.svg";